import { ProductMasterService } from "@/api/services/masterService";
import { vtcInService } from "@/api/services/transactionService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Define types for Product
interface Product {
  id: string;
  typeName: string;
  isd: string;
  currencyId: string;
  issuerId: string;
  issuerName?: string;
  ageLimit: string;
  productTypeId: string;
  currency: string;
  vendorName: string;
  status: number;
}

// Define state type
interface ProductMasterState {
  loading: boolean;
  ProductList: Product[];
  VTMProductList: Product[];
  VTCinList: Product[];
  error?: string;
}

// Initial state with type safety
const initialState: ProductMasterState = {
  loading: false,
  ProductList: [],
  VTMProductList:[],
  VTCinList: [],
  error: undefined,
};

// ✅ Fixed Async thunk with proper return type
export const fetchProductMaster = createAsyncThunk<
  Product[], 
  void, 
  { rejectValue: string }
>(
  "Product/fetchProductMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await ProductMasterService.getall();

      // If API returns { data: Product[] }, extract `data`
      return response.data ? response.data : response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch Product data");
    }
  }
);
export const fetchVTCInMaster = createAsyncThunk<
  Product[], 
  void, 
  { rejectValue: string }
>(
  "Product/fetchVTCInMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await vtcInService.getall();

      // If API returns { data: Product[] }, extract `data`
      return response.data ? response.data : response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch Product data");
    }
  }
);

// Create slice with strong typing
const productMasterSlice = createSlice({
  name: "ProductMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchProductMaster.fulfilled, (state, action: PayloadAction<Product[]>) => {
        state.ProductList = action.payload;
        state.VTMProductList = action.payload?.filter((item) => item.productTypeId === "01JM93P0R1XY91VHNK24FE29M6");
        state.loading = false;
      })
      .addCase(fetchProductMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(fetchVTCInMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchVTCInMaster.fulfilled, (state, action: PayloadAction<Product[]>) => {
        state.VTCinList = action.payload;
        state.loading = false;
      })
      .addCase(fetchVTCInMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// Export reducer
export default productMasterSlice.reducer;
